/* eslint-disable no-unused-vars */
import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";

import VueMeta from 'vue-meta';
import VueCarousel from 'vue-carousel';
import VueYouTubeEmbed from 'vue-youtube-embed';



//import VeeValidate from "vee-validate";
import * as VeeValidate from 'vee-validate';
import VueSweetalert2 from "vue-sweetalert2";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueScrollTo from 'vue-scrollto';
import { Slide } from 'vue-burger-menu';
import { TnSlider, TnItem } from 'thumbnail-slider';
import Nprogress from 'nprogress';
import Lightbox from 'lightbox2';

import VueAnalytics from 'vue-analytics';
import VueGtag from "vue-gtag";




// window.$ = JQuery;
//jQuery & bootstrap
 window.$ = window.jQuery = require("jquery");

import "bootstrap";


var owlCarousel = require("@/assets/js/owl.carousel.min.js");
var fancybox = require("@/assets/js/jquery.fancybox.min.js");
var owlCarouselThumb = require("@/assets/js/owl.carousel2.thumbs.min.js");

//App scss
import "@/assets/scss/app.scss";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

//

// Install BootstrapVue

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueScrollTo);
Vue.use(VueCarousel);
Vue.use(Slide);
Vue.use(VueMeta);


Vue.use(Lightbox);
Vue.use(Nprogress);
Vue.component('tn-slider', TnSlider);
Vue.component('tn-item', TnItem);
Vue.use(VueYouTubeEmbed);

Vue.use(VueAnalytics, {
  id: 'UA-177097640-1',
  router
});
Vue.use(VueGtag, {
  config: { id: "UA-177097640-1" }
});

//Globals
 window.APIURL = "https://silverstar.com.gh/admin/api/";

//window.APIURLs = "http://ultimate.tribalhousestudios.com/admin/webapi/";


//Vue use
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
Vue.use(ElementUI);


Vue.config.productionTip = false;

new Vue({
  router,
 
  render: h => h(App)
}).$mount("#app");
